/**
 * Registration form field configs derived from the central PlayerDataFields catalog.
 * These exports maintain backward compatibility with all existing consumers.
 */

import {
    registrationStaticFields,
    registrationEventSourcedFields,
    toRegistrationFieldItem,
} from './PlayerDataFields';
import type { RegistrationFieldsConfig } from '@moment-golf/types';

/** Standard registration fields (static options). Use as the default pool when building a form. */
export const standardRegistrationFields: RegistrationFieldsConfig =
    registrationStaticFields.map(toRegistrationFieldItem);

/** Event-sourced fields: options are resolved from event at runtime (e.g. flighting divisions/flights). */
export const eventSourcedRegistrationFields: RegistrationFieldsConfig =
    registrationEventSourcedFields.map(toRegistrationFieldItem);

/** All registration fields (standard + event-sourced) for use as the full available pool. */
export const allRegistrationFields: RegistrationFieldsConfig = [
    ...standardRegistrationFields,
    ...eventSourcedRegistrationFields,
];
